import { FlexAligner } from '@scaleaq/scaleui';
import { styled } from 'styled-components';

import { responsive } from '@/utils';

// ************************************
// CSS variables
// ************************************

const padding = `${responsive.spacing['xlarge']} 5%`;

// ************************************
// Styled components
// ************************************

export const StyledBody = styled(FlexAligner)`
  padding: ${padding};
`;
export const Footer = styled(FlexAligner)`
  padding: ${padding};
  min-height: 3.4375rem;
`;
